module.exports = __webpack_public_path__ + "static/img/profile.f470f2a8.jpg";